import React from 'react';
import { USER_PERMISSIONS_TEST_IDS } from 'pages/UserPermissions/UserPermissions.testIds';
import { InviteUserDialogProps } from './types';
import ActionDialog from '../../ActionDialog';
import InviteUserLedger from '../../InviteUserLedger';

const InviteUserDialog = ({
  handleDialogClose,
  dialogUserData,
  handleAddUserToFirm,
  company,
}: InviteUserDialogProps) => (
  <ActionDialog
    title="INVITE USER"
    handleDialogClose={handleDialogClose}
    open={dialogUserData.open}
    paperSx={{ width: '50vw', minWidth: 900, maxWidth: '95vw' }}>
    <div />
    <InviteUserLedger
      dialogUserData={dialogUserData}
      handleDialogClose={handleDialogClose}
      handleAddUserToFirm={handleAddUserToFirm}
      isCompanyInvite={company?.id !== undefined}
    />
  </ActionDialog>
);

export default InviteUserDialog;
